/** @format */
import useCallback from "react";
import { AddCircleOutline, Edit, SelectAll, UploadFile, X } from "@mui/icons-material";
import {
  Alert,
  Box,
  Badge,
  Button,
  Checkbox,
  Chip,
  Grid,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Modal,
  Popover,
  FormLabel,
  FormGroup,
  FormControl,
  FormControlLabel,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  TextField,
  Typography,
  Tooltip,
  useMediaQuery,
  Radio,
  RadioGroup,
  Link
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import FormTextArea from "../../components/FormTextArea/FormTextArea";
// import AddEditNotes from "../../pages/AddEditNotes/AddEditNotes";

import dayjs from 'dayjs';
import { visuallyHidden } from "@mui/utils";
import { useEffect, useMemo, useState, forwardRef, useImperativeHandle, useRef } from "react";
import { useHistory } from "react-router-dom";
import { IsNullOrEmpty, ReturnFullDateTimeOrString, isValidURL } from "../../helpers/Common";
import { FORM_MODES } from "../../helpers/Constants";
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import DownloadIcon from '@mui/icons-material/Download';
import './Table.css';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { green, pink } from '@mui/material/colors';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ReadMore from '../../components/ReadMore/ReadMore';
import CheckIcon from '@mui/icons-material/Check';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from '@mui/icons-material/Search';
import StyleIcon from '@mui/icons-material/Style';
import debounce from "../../helpers/Debounce";
import ReportIcon from '@mui/icons-material/Report';
import DangerousIcon from '@mui/icons-material/Dangerous';
import VerifiedIcon from '@mui/icons-material/Verified';
import PendingIcon from '@mui/icons-material/Pending';
import StartIcon from '@mui/icons-material/Start';
import DoneRoundedIcon from '@mui/icons-material/DoneRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import InfoIcon from '@mui/icons-material/Info';
import FormDialog from "../../components/FormDialog/FormDialog";
import ExcelExport from "../../components/ExcelExport/ExcelExport";
import SendIcon from '@mui/icons-material/Send';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import { set } from "lodash";
import { useCheckboxContext } from "./CheckboxContext";
import DeleteIcon from '@mui/icons-material/Delete';
import ExportButton from "./ExportButton";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import GroupsIcon from '@mui/icons-material/Groups';
import PauseIcon from '@mui/icons-material/Pause';
function EnhancedTableHead(props) {
  const { data, order, orderBy, onRequestSort, columns, sortableColumns, sortConfig, actionTabEnabled, downloadIconEnabled, filesIconEnabled, filesUploadIconEnabled, onSort, handleSelectAll, CheckBoxEnabled } = props;
  const { checkedItems, toggleCheckbox, toggleSelectAll, isCheckAll, setIsCheckAll, isCheck } = useCheckboxContext();
  const createSortHandler = (property) => (event) => {
    const existingSort = sortConfig.find(config => config.column === property);
    let newSortConfig;

    if (existingSort) {
      // Toggle direction or remove sort rule
      newSortConfig = sortConfig.map(config =>
        config.column === property
          ? { ...config, direction: config.direction === 'asc' ? 'desc' : config.direction === 'desc' ? null : 'asc' }
          : config
      ).filter(config => config.direction !== null);
    } else {
      // Add new sort rule
      newSortConfig = [...sortConfig, { column: property, direction: 'asc' }];
    }

    onSort(newSortConfig);
  };
  return (
    <TableHead sx={{ backgroundColor: "#9d9c9c", padding: "1px" }}>
      <TableRow >
        {CheckBoxEnabled &&
          <TableCell
            sx={{
              // border: "1px solid gray",
            }}>
            <Checkbox
              name="selectAll"
              id="selectAll"
              checked={isCheckAll}
              onChange={() => toggleSelectAll(data)}
            />
          </TableCell>
        }
        {columns?.map((column) => (
          <TableCell
            key={column.id}
            align="left"

            sx={{
              borderBottom: "1px solid gray",
            }}
            sortDirection={sortConfig.find(config => config.column === column.sortId)?.direction || false}
          >
            <TableSortLabel
              active={!!sortConfig.find(config => config.column === column.sortId)}
              direction={sortConfig.find(config => config.column === column.sortId)?.direction || 'asc'}
              onClick={createSortHandler(column.sortId)}
            >
              <p className="text-[#8a2432] font-bold mb-6">{column.label}</p>
              {sortConfig.find(config => config.column === column.sortId) ? (
                <Box component="span" sx={visuallyHidden}>

                  {sortConfig.find(config => config.column === column.sortId).direction === 'desc'
                    ? 'sorted descending'
                    : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
        {actionTabEnabled &&
          <TableCell
            align="left"
            sx={{
              borderBottom: "1px solid gray",
            }}
          >
            <p className="text-pink-800 font-bold mb-6 text-center">Actions</p>
          </TableCell>
        }
      </TableRow>
    </TableHead>
  );
};

const useDialog = (listOfCheckIds) => {
  const [open, setOpen] = useState(false);

  const openDialog = () => {
    setOpen(true);
  };
  async function handleSendNotes(noteObj) {
    var result = window.confirm("Are you sure to send notes to these adjusters?");
    if (result) {
      let params = {
        NonComplianceAlertIds: listOfCheckIds.join(','),
        categoryId: noteObj?.noteCategoryId,
        stateId: noteObj?.stateId,
        noteContent: noteObj?.noteContent
      };

      await fetch(`/api/PersonNote/CreateMultiplePersonNote`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
      })
        .then(response => response.json())
        .then(data => {
          localStorage.setItem('isSendNote', true);
        })
        .catch(error => {
          localStorage.setItem('isSendNote', false);
        });
    }
  };
  const handleClose = () => {
    setOpen(false);
    window.location.reload(false);
  };
  const props = {
    open,
    handleClose,
    handleSendNotes
  };
  return [openDialog, props];
};

export default function CustomTable({
  data,
  columns,
  sortableColumns,
  pageSize,
  routing,
  eventUserListRouting,
  tabData,
  downloadIconEnabled,
  filesIconEnabled,
  actionTabEnabled,
  filesUploadIconEnabled,
  ActivePendingIconEnabled,
  EditEnabled,
  AddEnabled,
  NotesEnabled,
  Renew,
  skip,
  limit,
  fileDownloadUrl,
  getStormInfoEnabled,
  tab,
  CheckBoxEnabled,
  DeleteEnabled,
  EventStartEnabled,
  UserListEnabled
}) {
  const { setCurrentPageItems, checkedItems, toggleCheckbox, toggleSelectAll, isCheckAll, isCheck, setIsCheckAll, reConfigureCheckboxes, isCheckExportedRows, setIsCheckExportedRows, setIsCheck } = useCheckboxContext();
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(pageSize);
  const [rows, setRows] = useState(tabData?.$values ?? []);
  const history = useHistory();
  const isMobile = useMediaQuery("(max-width:768px)");
  const isMiniMobile = useMediaQuery("(max-width:400px)");
  const isDesktop = !isMobile;
  const [hideFileIcon, setHideFileIcon] = useState(false);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(undefined);
  const [searchInput, setSearchInput] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const roles = localStorage.getItem("roles") ? localStorage.getItem("roles")?.split(",") : [];
  const adminRole = roles && roles.length > 0 && roles.find((role) => role.toLowerCase().includes("checkinappadmin"))
  const [defaultEventId, setDefaultEventId] = useState(localStorage.getItem('defaultEventId')); //Remove later

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };
  const bulkLicenseOnChange = (mode, id) => {
    history.push({ pathname: "\BulkLicenseRequestError", state: { id: id, mode: mode } });
  };
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleEdit = (mode, id) => {
    history.push({ pathname: routing, state: { id: id, mode: mode } });
  };

  const handleAdd = (mode, id) => {
    history.push({ pathname: routing, state: { id: id, mode: mode } });
  };

  const handleDelete = async (id) => {
    var result = window.confirm(`Are you sure to delete event - ${id}?`);
    if (result) {
      await fetch(`/api/Event/UpdateEventSoftDelete?eventId=${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' }
      })
        .then(response => response.json())
        .then(data => {
          getData();
        })
        .catch(error => {
          setStatus({ type: 'error', error });
        });
    }
  };
  const handleEventStart = (id, isPaused, eventName) => {
    if (!isPaused) {
      localStorage.setItem('defaultEventId', id);   
      setDefaultEventId(id?.toString());
      localStorage.setItem('defaultEventName', eventName ?? '');   
      localStorage.setItem('roles', "");
      localStorage.setItem('pilotId', "");
      localStorage.setItem('loginUserName', "");
      window.location.replace("/logout");
    }
    else {
      localStorage.setItem('defaultEventId', "");
      localStorage.setItem('defaultEventName', '');
      setDefaultEventId("");
      getData();
    }
    localStorage.setItem('tempDefaultEventId', '');
  }
  const handleUserList = (id) => {
    setLoading(true);
    history.push({ pathname: eventUserListRouting, state: { id: id } });
    setLoading(false);
  };

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const [useRows, setUseRows] = useState([]);
  const [sortConfig, setSortConfig] = useState([]);

  const [sortBy, setSortBy] = useState();

  const getData = async () => {
    setUseRows([]);
    setLoading(true);

    let sortParams = Object.entries(sortConfig)?.map(([key, value]) =>
      `${value.column} ${value.direction}`).join(', ');
    //   alert('loading::::::   ' + sortParams)

    try {
      var search = localStorage.getItem('searchInput');
      if (search !== null && search !== undefined) {
        setSearchInput(search);
      }

      fetch(`/api/Event/GetAllEventsSorted`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          "filter": `${search?.trim() ?? ""}`,
          "skip": `${page}`,
          "take": `${rowsPerPage}`,
          "filterBy": `all`, //Future enhancement
          "sortParams": `${sortParams}`,
          "EventStatus": `${activeOrInactiveOrAll}`,
        })
      })
        .then((response) => response.json())
        .then((data) => {
          setUseRows(data?.events?.$values);
          setLoading(false);
          setTotalCount(data?.count);
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
          setLoading(false);
        });
    } catch (ex) {
      setLoading(false);
    }


  };

  useEffect(() => {
    setIsCheckAll(false);
    setIsCheckExportedRows([]);
    setIsCheck([]);
  }, [searchInput, tab]);

  useEffect(() => {
    const timeoutId = setTimeout(() =>
      getData()
      , 1000);
    return () => clearTimeout(timeoutId);
  }, [searchInput]);

  const [list, setList] = useState([]);

  useEffect(() => {
    setList(useRows);
  }, [list]);

  const Catalog = (item) => {
    return (
      <>
        <Checkbox
          key={item.id}
          type="checkbox"
          name={item.id}
          id={item.id}
          // onChange={handleClick}
          onChange={(e) => toggleCheckbox(e, useRows)}
          checked={isCheck.includes(item.id.toString())}
        // checked={!!checkedItems[item.id]}
        />
        {/* {item.id} */}
      </>
    );
  };
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    // ...theme.typography.body2,
    // padding: theme.spacing(1),
    textAlign: 'left',
    // color: theme.palette.text.secondary,
    ...theme.applyStyles('dark', {
      backgroundColor: '#ffffff',
      border: 0
    }),
  }));
  const OpenDialog = () => {
    openDialog(isCheck);
  }

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    unregister,
    watch,
    control,
    clearErrors,
    formState: { errors },
  } = useForm();


  const [noteContent, setNoteContent] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const openAnchor = Boolean(anchorEl);
  const [openDialog, dialogProps] = useDialog(isCheck);
  const [close, setClose] = useState(false);
  const [open, setOpen] = useState(false);
  const enhancedTableHeadRef = useRef(null);
  const childRef = useRef(null);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    // Reset isCheckAll when data changes (e.g., paging, sorting, searching)
    //setIsCheckAll(false);
  }, [useRows]);

  const [activeOrInactiveOrAll, setActiveOrInactiveOrAll] = useState("all");
  const handleRadioButtonChange = (event) => {
    setActiveOrInactiveOrAll(event.target.value);
    setRowsPerPage(5);
    setPage(0);
  };
  useEffect(() => {
    setLoading(true);
    getData();

    // }, [rowsPerPage, page, order, orderBy, searchInput]);

  }, [sortConfig, rowsPerPage, page, orderBy, activeOrInactiveOrAll]);

  useEffect(() => {
    setPage(0)
    setRowsPerPage(5);
    getData();
  }, [searchInput]);

  useEffect(() => {
    if (IsNullOrEmpty(defaultEventId) || !useRows?.length) {
      return;
    }

    const isStartedEventEnded = useRows.some(
      (row) => row.id == defaultEventId && dayjs(row.eventEndDate).format('YYYY-MM-DD') < dayjs().format('YYYY-MM-DD')
    );

    if (isStartedEventEnded) {
      localStorage.setItem('defaultEventId', "");
      setDefaultEventId("");
      localStorage.setItem('eventInactiveMessage', 'The previously selected event is no longer active. Please select another active event.');
      setStatus({
        type: 'warning',
        message: 'The previously selected event is no longer active. Please select another active event.'
      });
    }
  }, [defaultEventId, useRows]);


  return (
    <>
      {/* <FormDialog {...dialogProps} title="Send notes to multiple adjusters">
        <AddEditNotes mode='New' id='0' pilotId='0' isDialog={true} {...dialogProps} />
      </FormDialog> */}
      {/* {isDesktop && ( */}
      <Box sx={{ width: "100%" }}>
        <Paper sx={{ width: "100%" }}>
          {status?.type === 'success' &&
            <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
              Download successfully!
            </Alert>}
          {status?.type === 'error' && (
            <Alert variant="filled" severity="error">
              Error occurs!
            </Alert>
          )}
          {status?.type === 'warning' && (
            <Alert severity="warning">
              {status?.message}
            </Alert>
          )}
          <div class="grid grid-cols-1">
            {/* <div class="justifyContent: 'flex-end'"> */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '16px' }}>
              <TextField
                sx={{ border: 'none', borderRadius: '10px', marginRight: '6px', "& fieldset": { border: 'none' }, backgroundColor: '#f0f0f0' }}
                value={searchInput}
                onChange={(e) => {
                  setSearchInput(e.target.value);
                  localStorage.setItem('searchInput', e.target.value);
                  // handleOnChange(e.target.value);
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment>
                      <IconButton>
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
              <FormControl component="fieldset">
                <RadioGroup row name="filter" defaultValue="all" onChange={handleRadioButtonChange}>
                  <FormControlLabel value="active" control={<Radio />} label="Active" />
                  <FormControlLabel value="inactive" control={<Radio />} label="Inactive" />
                  <FormControlLabel value="all" control={<Radio />} label="All" />
                </RadioGroup>
              </FormControl>
            </Box>
            {/* </div> */}
          </div>


          <TableContainer>
            <Table
              sx={{ minWidth: 750 }}
              aria-labelledby="tableTitle"
              size="medium"
            >
              <EnhancedTableHead
                data={useRows}
                order={order}
                orderBy={orderBy}
                sortBy={sortBy}
                sortConfig={sortConfig}
                onRequestSort={handleRequestSort}
                columns={columns}
                sortableColumns={sortableColumns}
                actionTabEnabled={actionTabEnabled}
                downloadIconEnabled={downloadIconEnabled}
                filesIconEnabled={filesIconEnabled}
                filesUploadIconEnabled={filesUploadIconEnabled}
                onSort={setSortConfig}
                CheckBoxEnabled={CheckBoxEnabled}
              />
              <TableBody>
                {useRows?.length === 0 ? (
                  <TableRow
                    tabIndex={-1}
                    sx={{
                      cursor: "pointer",
                      backgroundColor: "#f0f0f0",
                    }}
                  >
                    <TableCell colSpan={columns.length + 2}>
                      <Alert severity="info" sx={{ fontSize: "15px" }}>
                        No record was found.
                      </Alert>
                    </TableCell>
                  </TableRow>
                ) : (
                  <>
                    {useRows?.map((item, index) => {
                      return (
                        <TableRow
                          tabIndex={-1}
                          key={item.id}
                          sx={{
                            backgroundColor: index % 2 ? "#d8d8d8" : "#f0f0f0",
                            // border: "1px solid gray",
                          }}
                        >
                          {/* Add Checkbox for each row */}
                          {CheckBoxEnabled &&
                            <TableCell
                              component="th"
                              scope="row"
                              align="left"
                              sx={{
                                // border: "1px solid gray",
                              }}
                            >
                              {/* {item.id} */}
                              <Catalog
                                id={item.id}
                                person={item.personId}
                              />
                            </TableCell>
                          }
                          {columns?.map((column, index) => (
                            <TableCell
                              key={index}
                              component="th"
                              scope="row"
                              align="left"
                              sx={{
                                // border: "1px solid gray",
                              }}
                            >
                              <Typography paddingBottom="3px">
                                <ReadMore
                                  id="read-more-text"
                                  maxLength={140}
                                  index={140}
                                  body={ReturnFullDateTimeOrString(item[`${column?.id}`]) ?? "--"}
                                ></ReadMore>
                              </Typography>
                            </TableCell>
                          ))}
                          <TableCell>
                            <div class="grid content-start gap-2">
                              <div class="col-start-1 col-end-2">
                                {adminRole && EditEnabled &&
                                  <Button
                                    sx={{ color: "black" }}
                                    onClick={() => handleEdit(FORM_MODES.edit, item.id)}
                                  >
                                    <Tooltip openDelay={50} placement="top" title="Edit">
                                      <Edit />
                                    </Tooltip>
                                  </Button>
                                }
                              </div>
                              <div class="col-start-3 col-end-4">
                                {adminRole && DeleteEnabled &&
                                  <Button
                                    sx={{ color: "black" }}
                                    onClick={() => handleDelete(item.id)}
                                  >
                                    <Tooltip openDelay={50} placement="top" title="Delete">
                                      <DeleteIcon />
                                    </Tooltip>
                                  </Button>
                                }
                              </div>
                              <div class="col-start-5 col-end-6">
                                {EventStartEnabled && (() => {
                                  const isEventEnded = dayjs(item.eventEndDate).format('YYYY-MM-DD') < dayjs().format('YYYY-MM-DD');
                                  const isEventActiveWindow = dayjs(item.eventDate).format('YYYY-MM-DD') <= dayjs().format('YYYY-MM-DD')
                                    && dayjs(item.eventEndDate).format('YYYY-MM-DD') >= dayjs().format('YYYY-MM-DD');
                                  const isStarted = !IsNullOrEmpty(defaultEventId) && defaultEventId == item.id;

                                  return (
                                    <Button
                                      sx={{ color: "black" }}
                                      onClick={() => handleEventStart(item.id, isStarted)}
                                      disabled={isEventEnded || !isEventActiveWindow}
                                    >
                                      <Tooltip
                                        openDelay={50}
                                        placement="top"
                                        title={isEventEnded ? "Event Ended" : isStarted ? "Event Started" : "Event Paused"}
                                      >
                                        {!isEventEnded && isStarted ? <PauseIcon sx={{ color: "green" }} /> : <PlayArrowIcon />}
                                      </Tooltip>
                                    </Button>
                                  );
                                })()}
                              </div>
                              <div class="col-start-7 col-end-8">
                                {UserListEnabled &&
                                  <Button
                                    sx={{ color: "black" }}
                                    onClick={() => handleUserList(item.id)}
                                  >
                                    <Tooltip openDelay={50} placement="top" title="UserList">
                                      <GroupsIcon />
                                    </Tooltip>
                                  </Button>
                                }
                              </div>
                            </div>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            //   count={rows?.length}
            count={totalCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>

        {adminRole && AddEnabled &&
          <Box
            sx={{
              marginTop: "16px",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              paddingX: "12px",
            }}
          >
            {/* {data?.id} */}
            <Button
              sx={{ color: "black", width: "32px", minWidth: "0px" }}
              onClick={() => handleAdd(FORM_MODES.add, data?.id)}
            >
              <Tooltip openDelay={50} placement="top" title="Add">
                <AddCircleOutline fontSize="large" />
              </Tooltip>
            </Button>
            {ActivePendingIconEnabled &&
              <Typography>
                Active/Pending License: {data?.activeLicenses?.apCount}
              </Typography>
            }
          </Box>

        }
      </Box>

      {/* } */}




      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}
